import { createUseStyles } from 'react-jss';
import colors, { backgrounds, fonts, texts } from '../../utils/theme';

export default createUseStyles({
  shadow: {
    boxShadow: '0px 4px 8px -4px rgba(23, 23, 23, 0.25)',
  },
  box: {
    border: `1px solid ${backgrounds.bg1}`,
    background: 'white',
    maxWidth: 'calc(100vw - 32px)',
    boxSizing: 'border-box',
  },
  detailImage: {
    '@media (max-width: 767px)': {
      maxWidth: 'calc(100vw - 32px)',
    },
  },
  tabsContainer: {
    '& .ant-tabs-nav-list': {
      width: '100%',
    },
    '@media (max-width: 767px)': {
      '& .ant-tabs-nav-list': {
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '16px',
        '& .ant-tabs-tab': {
          margin: 0,
          padding: '0 !important',
          '& button': {
            paddingLeft: '8px',
            paddingRight: '8px',
            fontFamily: fonts.IBMPlexSansBold,
            color: texts.text2,
          },
        },
        '& .ant-tabs-ink-bar': {
          display: 'none',
        },
      },
    },
    '& .ant-tabs-tab-disabled': {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'default !important',
    },
  },
  selectedTabInMobile: {
    backgroundColor: backgrounds.bg3,
    color: `${colors.primary} !important`,
    '&:hover': {
      backgroundColor: `${backgrounds.bg3} !important`,
    },
  },
});
